import styled from 'styled-components';

export const StatusGrid = styled.dl`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[6]};
  margin: 0;

  dt {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: ${({ theme }) => theme.fontSizes.sm};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }

  dd {
    margin: 0;
    color: ${({ theme }) => theme.colors.gray900};
    font-size: ${({ theme }) => theme.fontSizes.sm};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
  }
`;

export const TrialBadge = styled.span`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.successBgSubtle};
  color: ${({ theme }) => theme.colors.success};
  border: 1px solid ${({ theme }) => theme.colors.successBorderSubtle};
  border-radius: 999px;
  padding: 4px 12px;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const EmptyText = styled.p`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  margin: 0;
`;

export const DangerCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.dangerBorder};
  background-color: ${({ theme }) => theme.colors.dangerBg};
  border-radius: 12px;
  padding: ${({ theme }) => theme.spacing[5]};
`;

export const DangerDescription = styled.p`
  color: ${({ theme }) => theme.colors.gray700};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.normal};
  margin: 0 0 ${({ theme }) => theme.spacing[4]};
`;

export const DangerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.danger};
  color: ${({ theme }) => theme.colors.textInverse};
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 0.9375rem;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  cursor: pointer;
  transition: opacity ${({ theme }) => theme.transitions.fast};

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FeedbackMessage = styled.div<{ $variant: 'success' | 'error' }>`
  margin-top: ${({ theme }) => theme.spacing[3]};
  border-radius: 8px;
  padding: 10px 14px;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  background-color: ${({ theme, $variant }) =>
    $variant === 'success' ? theme.colors.successBgSubtle : theme.colors.dangerBg};
  border: 1px solid
    ${({ theme, $variant }) =>
      $variant === 'success' ? theme.colors.successBorderSubtle : theme.colors.dangerBorder};
  color: ${({ theme, $variant }) => ($variant === 'success' ? theme.colors.success : theme.colors.danger)};
`;
